/* How to install 
 * 1. 
 *       import dynamicFontSizeMixin from '@/mixin/dynamicFontSizeMixin'
 *       mixins: [dynamicFontSizeMixin],
 * 2. Add Fontsize vue (buttons)
 * 3. Add fontsize to class in navigation
 */

export default {
    data() {
        return {
            rootEl:['.fontsize'], 
            initialFontSize: {
                
                'h3' : null,
                'h4' : null,
                'h5' : null,
                '.overlay h5': null,
                '.overlay p': null,
                '.link':null,
                '.link-2':null,
                '.link-3':null,
                '.content-container p':null,
                '.content-container h2':null
            },

            ignoreSelector: ['.table-diagram p']
        }
    },
    mounted(){
        
        this.$nextTick(function () {
            let that = this;

            // get initial font size for the first time
            for(const selector in that.initialFontSize){
                for(let i = 0; i < that.rootEl.length; i++){
                    let el = document.querySelector(that.rootEl+' '+selector);
                    if(el){
                        that.initialFontSize[selector] = parseFloat(window.getComputedStyle(el).fontSize);
                    }
                }
            };
        });
    },
    methods: {
        mobileAndTabletCheck (){
            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;    
        },

        //runs a increase base on size. 
        fontsizeChange(scale, initialSize, rootEl, ignoreSelector){
            // font size scale
            let size = {1: 0.7, 2: 0.8, 3:1, 4:1.3, 5:1.5};

            for(const selector in initialSize){
                for(let i = 0; i < rootEl.length ; i++){
                    let elements = document.querySelectorAll(rootEl[i]+' '+selector);
                    if(initialSize[selector]){
                        let originalSize = parseFloat(initialSize[selector]);
                        elements.forEach(function(el, index){
                            // state 3 (original size)
                            if(scale==3){
                                el.style.fontSize = null;
                            }else{
                                el.style.fontSize = originalSize * size[scale] +'px';
                            }
                        });
                    }
                }
                if(ignoreSelector){
                    for(let i = 0; i < ignoreSelector.length ; i++){
                        let ignoreElements = document.querySelectorAll(ignoreSelector[i]);
                        if(ignoreElements.length > 0 ){
                            ignoreElements.forEach(function(el, index){
                                el.style.fontSize = null;
                            });
                        }
                    }
                } //endif
            }//endfor
        }//end func



    }, //end methods



    computed: {
        fontsize() {
            this.fontsizeChange(this.$store.state.fontsize, this.initialFontSize, this.rootEl, this.ignoreSelector);
            return this.$store.getters.size;
        }
    },
}